import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Currency } from '@app/model/currency';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { PaymentMethodDetailService } from '@app/service/payment-method-detail/payment-method-details.service';
import { RecordingService } from '@app/service/recording-service/recording.service';
import {
  CheckoutType,
  RedirectService,
} from '@app/service/redirect-service/redirect.service';
import { StateService, WaitThen } from '@app/service/state/state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'no-success',
  templateUrl: './no-success.component.html',
  styleUrls: ['../../page-shared.css', './no-success.component.scss'],
})
export class NoSuccessComponent extends RouteComponent implements OnInit {
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private paymentDetail: PaymentMethodDetailService,
    private recordingService: RecordingService,
    private redirectService: RedirectService
  ) {
    super(router, route, stateService, headerService);
  }

  amount: number;
  currency: Currency;
  paymentMethod: string;

  successUrl: string;
  loading: boolean = true;
  noResponseMessage: string;

  public readonly APP_STORE_LINK =
    'https://apps.apple.com/no/app/zaver-handla-på-dina-villkor/id1560858500';
  public readonly PLAY_STORE_LINK =
    'https://play.google.com/store/apps/details?id=io.zaver.app';

  ngOnInit(): void {
    this.paymentMethod = this.paymentDetail.getMethodTitle(
      this.state.paymentInformation.paymentMethod,
      this.state.market
    );

    // Wait a short time before saving events.
    setTimeout(() => {
      this.recordingService.saveSuccessRecording();
    }, 800) as unknown as number;

    this.tryRedirectToSuccessUrl();
  }

  public openTab(url: string): void {
    window.open(url);
  }

  onRouteToSuccessUrl(): void {
    window.location.href = this.successUrl;
  }
  
  async tryRedirectToSuccessUrl(): Promise<void> {
    let redirectSubscription: Subscription;

    // If the readyToLeave endpoint takes to long time,
    // just show the success page after 5 seconds with redirect button.
    // this should be handle by the backend but quick fix for now.
    const timeoutId = setTimeout(() => {
      this.loading = false;
      this.successUrl = this.state.merchantUrls?.onSuccessUrl;

      if (redirectSubscription) {
        redirectSubscription.unsubscribe();
      }
    }, 5000);

    redirectSubscription = (
      await this.redirectService.tryRedirect(CheckoutType.BACKEND_DRIVEN_CHECKOUT, true)
    ).subscribe((stayOrLeave) => {
      switch (stayOrLeave.then) {
        case WaitThen.WAIT:
          break;
        case WaitThen.STAY:
          clearTimeout(timeoutId);
          this.loading = false;
          this.successUrl = this.state.merchantUrls?.onSuccessUrl;
          break;
        case WaitThen.LEAVE:
          clearTimeout(timeoutId);
          this.successUrl = this.state.merchantUrls?.onSuccessUrl;
          // Don't stop the loading there as the redirection is handled 
          break;
      }
    });
  }
}
